import React, { useState } from 'react';
import omit from 'lodash/omit';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';
import { getLang } from '~/commons/helpers';
import { getAcadYears } from '../../helpers';

const api = '/api/core/users/opens';
const acadYears = getAcadYears();

const ListOpens = (props) => {
  const { deactivateAll } = props;
  const [active, setActive] = useState('');
  const [acadYear, setAcadYear] = useState('');
  const { t, i18n } = useTranslation();

  const filter = {};

  if (active) filter.active = active;
  if (acadYear) filter['open.acadYear'] = acadYear;

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { 'name.full.en': 1 },
        filter,
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={active}
            onChange={(e) => setActive(e.target.value)}
          >
            <option value="">{t('Status')}</option>
            <option value={true}>{t('Active')}</option>
            <option value={false}>{t('Not Active')}</option>
          </select>,
          <select
            className="custom-select"
            key={1}
            value={acadYear}
            onChange={(e) => setAcadYear(e.target.value)}
          >
            <option value="">{t('Year')}</option>
            {acadYears.map((v) => (
              <option key={v} value={v}>{v}</option>
            ))}
          </select>,
        ],
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => getLang(r.name.full, i18n),
          },
          {
            key: 'active',
            getter(v) {
              return (
                <FA icon={v ? faEye : faEyeSlash} />
              );
            },
          },
          { key: 'email', sortable: true },
          { key: 'open.category', children: 'Identity' },
          { key: 'open.school', children: 'School' },
          { 
            key: 'open.acadYear', 
            children: 'Year',
            getter: (v) => (`${v}/${v+1}`),
          },
        ],
        ...omit(props, 'school'),
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates
          api={api}
          deactivateAll={deactivateAll}
          selected={selected}
          onSuccess={refresh}
        />
      )}
    </ListResource>
  );
};

export default ListOpens;
